module.exports = __webpack_public_path__ + "img/news-bg.5d21b9ba.jpg";